/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateRoleRequest } from '../models/CreateRoleRequest';
import type { CreateRoleResponse } from '../models/CreateRoleResponse';
import type { GetRoleResponse } from '../models/GetRoleResponse';
import type { GetRolesListResponse } from '../models/GetRolesListResponse';
import type { ListSortDirection } from '../models/ListSortDirection';
import type { UpdateLegalEntityRolesRequest } from '../models/UpdateLegalEntityRolesRequest';
import type { UpdateRoleRequest } from '../models/UpdateRoleRequest';
import type { UpdateRoleResponse } from '../models/UpdateRoleResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class IdentityRolesService {
    /**
     * Updates an existing role with new details, permissions, and legal entity associations.
     * This endpoint allows updating an existing role by specifying the role's ID and providing
     * updated details such as name, description, permissions, and legal entity associations.
     * @param id The unique identifier of the role to be updated.
     * @param requestBody
     * @returns UpdateRoleResponse The role has been successfully updated.
     * @throws ApiError
     */
    public static updateRoleEndpoint(
        id: string,
        requestBody: UpdateRoleRequest,
    ): CancelablePromise<UpdateRoleResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/roles/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The request contains invalid or incomplete parameters.`,
                401: `The user is not authorized to perform this action.`,
                403: `Forbidden`,
                404: `The specified role was not found.`,
            },
        });
    }
    /**
     * Retrieves details of a specific role.
     * This endpoint fetches the details of a role by its unique identifier, including its name,
     * description, permissions, and associated legal entities.
     * @param id The unique identifier of the role to retrieve.
     * @returns GetRoleResponse The role details have been successfully retrieved.
     * @throws ApiError
     */
    public static getRoleEndpoint(
        id: string,
    ): CancelablePromise<GetRoleResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/roles/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `The user is not authorized to access this resource.`,
                403: `Forbidden`,
                404: `The specified role was not found.`,
            },
        });
    }
    /**
     * Deletes role.
     * Removes a system role.
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteRoleEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/roles/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Not authorized.`,
                403: `Forbidden`,
                404: `Not found.`,
            },
        });
    }
    /**
     * Updates an existing legal entities with roles.
     * This endpoint allows updating  Legal Entity roles with providing roles.
     * @param legalEntityId The unique identifier of the legal entity to be updated.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updateLegalEntityRolesEndpoint(
        legalEntityId: string,
        requestBody: UpdateLegalEntityRolesRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/legal-entities/{legalEntityId}/roles',
            path: {
                'legalEntityId': legalEntityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The request contains invalid or incomplete parameters.`,
                401: `The user is not authorized to perform this action.`,
                403: `Forbidden`,
                404: `The specified role was not found.`,
            },
        });
    }
    /**
     * Retrieves a list of roles with optional search and sorting.
     * Fetches a paginated list of roles with optional filtering by search term and sorting by specified columns.
     * @param searchTerm An optional search term to filter roles by name.
     * @param sortBy The column name by which to sort the results. Allowed values: Name
     * @param sortDirection The sorting direction (Ascending or Descending).
     * @param legalEntityId
     * @returns GetRolesListResponse Successfully fetched a list of roles.
     * @throws ApiError
     */
    public static getRolesListEndpoint(
        searchTerm?: string | null,
        sortBy?: string | null,
        sortDirection?: ListSortDirection | null,
        legalEntityId?: string | null,
    ): CancelablePromise<GetRolesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/roles',
            query: {
                'searchTerm': searchTerm,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
                'legalEntityId': legalEntityId,
            },
            errors: {
                400: `The request parameters are invalid.`,
                401: `The user is not authorized to access this resource.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Creates a new role with specified permissions and legal entities.
     * This endpoint allows creating a new role by providing a name, optional description, associated permissions,
     * and legal entity associations.
     * @param requestBody
     * @returns CreateRoleResponse The role has been successfully created.
     * @throws ApiError
     */
    public static createRoleEndpoint(
        requestBody: CreateRoleRequest,
    ): CancelablePromise<CreateRoleResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/roles',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The request is invalid or contains incomplete parameters.`,
                401: `The user is not authorized to perform this action.`,
                403: `Forbidden`,
                409: `A role with the same name already exists.`,
            },
        });
    }
}
